import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { AppNameService, AuthService, ThemeService } from '@front-shared-lib';
import { AppEnvironmentService } from '../../../shared-lib/src/lib/services/app-environment.service';
import { environment, serverAddresses } from '../environments/environment';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent
implements OnInit {
  title = 'Eagle Info Solutions - Super Admin';

  constructor(
    public auth: AuthService,
    private metaTagService: Meta,
    private titleService: Title,
    private appName: AppNameService,
    private themeService: ThemeService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    this.appName.name = 'Eagle Info Solutions Admin Portal';
    this.metaTagService.addTags([
      {
        name: 'keywords',
        content: 'Admin Panel, Eagle Info Solutions, Management'
      },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'admin@eagleinfosolutions.com' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      {
        name: 'date',
        content: new Date().toISOString().slice(0, 10),
        scheme: 'YYYY-MM-DD'
      },
      { charset: 'UTF-8' },
      { name: 'twitter:card', content: 'summary' },
      { name: 'twitter:site', content: 'Eagle Info Solutions Admin Panel' },
      { name: 'twitter:image', content: 'URL_to_your_image' },
      { name: 'twitter:title', content: 'Eagle Info Solutions Admin Panel' },
      { name: 'twitter:description', content: 'Manage your Eagle Info Solutions resources' },


      {
        name: 'twitter:description',
        content: 'Manage your Eagle Info Solutions resources'
      },
      {
        name: 'twitter:text:description',
        content: 'Manage your Eagle Info Solutions resources'
      },
      {
        name: 'twitter:image',
        content: 'https://eagleinfosolutions.com/logo.png'
      }
    ]);
    this.titleService.setTitle('Eagle Info Solutions Admin Portal');
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      // this.auth.getToken(AppEnvironmentService.environment);
      this.themeService.initTheme();
    }


    AppEnvironmentService.environment = {
      production: environment.production
    };
    this.auth.initAllClients(serverAddresses, environment.production, 'superAdmin');
  }
}
